import classicMapVariant from "./classic";
import { resolveMapVariant } from "./registry";
import { MapVariant } from "./types";

/*
当前生效的地图变体。

渲染与逻辑代码统一通过 getActiveMapVariant() 读取地图数据，而不是
直接 import data/map/variants/classic/*。这样只要在游戏数据加载前
调用 setActiveMapVariantFromGame(...)，整套地图（几何、映射、纹理、
底图组件、画布尺寸）就会随之切换。

默认值 = classic，保证未登录/未选变体时行为与改造前完全一致。
*/

let activeMapVariant: MapVariant = classicMapVariant;

export function getActiveMapVariant(): MapVariant {
  return activeMapVariant;
}

/** 棋子图标边长（地图坐标）：变体可用 unitSize 覆盖，默认 75 */
export function getUnitSize(): number {
  return activeMapVariant.unitSize || 75;
}

/**
 * 省份的对外显示名（本地化名称）。
 *
 * 省份键（如 REGION_1 / PARIS）只是内部标识，不能直接展示给玩家；
 * 变体的 territoryToWebdipName 保存了后端使用的显示名（本图是中文名）。
 * 找不到时依次退回缩写、省份键，保证任何地图都不会显示成内部 id。
 */
export function getProvinceDisplayName(province: string): string {
  if (!province) return "";
  const variant = activeMapVariant;
  return (
    variant.territoryToWebdipName?.[province] ||
    variant.provincesMapData?.[province]?.abbr ||
    province
  );
}

export function setActiveMapVariant(variant: MapVariant): void {
  activeMapVariant = variant;
}

/** 依据游戏携带的 variantID / mapID 切换当前地图，返回解析结果 */
export function setActiveMapVariantFromGame(
  params: {
    variantID?: number;
    mapID?: number;
  } = {},
): MapVariant {
  activeMapVariant = resolveMapVariant(params);
  return activeMapVariant;
}
